export const cleanObject = obj => {
	for (var propName in obj) {
		if (obj[propName] === null || obj[propName] === undefined) {
			delete obj[propName]
		}
	}
	return obj
}

export function getSeasonColors(seasonId) {
	const season = seasonId ?? WC?.PageVars?.season

	if (![2, 4].includes(season)) {
		return false
	}

	return [
		{},
		{
			lightest: '#a1efa6',
			lighter: '#87c98b',
			main: '#6EA371',
			darker: '#4b704d',
			darkest: '#3a563b',
		},
		{},
		{
			lightest: '#249eff',
			lighter: '#208ee5',
			main: '#1b77bf',
			darker: '#13578c',
			darkest: '#104772',
		},
	][season - 1]
}
